import { CALL_API } from '../../../middleware/api';
import * as API from '../../../services/ApiEndpointsConstants';
import { apiEndpoints } from '../../../services/ApiEndpointsConstants';
import * as CommonConstants from './CommonConstants';

export function getDomainData(domainId) {
  return {
    [CALL_API]: {
      endpoint: apiEndpoints()
        .entity(API.GET_DOMAIN_DATA)
        .replace('{domainId}', domainId),
      types: [
        CommonConstants.GET_DOMAIN_DATA_REQUEST,
        CommonConstants.GET_DOMAIN_DATA_SUCCESS,
        CommonConstants.GET_DOMAIN_DATA_FAILED
      ]
    }
  };
}

export function getNoCommercialReasons() {
  return {
    [CALL_API]: {
      endpoint: `${apiEndpoints().entity(API.NO_COMMERCIAL_REASONS)}`,
      types: [
        CommonConstants.GET_NO_COMMERCIAL_REASONS_REQUEST,
        CommonConstants.GET_NO_COMMERCIAL_REASONS_SUCCESS,
        CommonConstants.GET_NO_COMMERCIAL_REASONS_FAILED
      ]
    }
  };
}

export function getImagesTableAgencies() {
  return {
    [CALL_API]: {
      endpoint: apiEndpoints().entity(API.GET_IMAGES_TABLE_AGENCIES),
      types: [
        CommonConstants.GET_IMAGES_TABLE_AGENCIES_REQUEST,
        CommonConstants.GET_IMAGES_TABLE_AGENCIES_SUCCESS,
        CommonConstants.GET_IMAGES_TABLE_AGENCIES_FAILED
      ]
    }
  };
}

export function getImageData(imageId) {
  return {
    [CALL_API]: {
      endpoint: apiEndpoints()
        .entity(API.GET_IMAGE_DATA)
        .replace('{imageId}', imageId),
      types: [
        CommonConstants.GET_IMAGE_DATA_REQUEST,
        CommonConstants.GET_IMAGE_DATA_SUCCESS,
        CommonConstants.GET_IMAGE_DATA_FAILED
      ]
    }
  };
}

export function getLanguages() {
  return {
    [CALL_API]: {
      endpoint: apiEndpoints().entity(API.GET_LANGUAGES),
      types: [
        CommonConstants.GET_LANGUAGES_REQUEST,
        CommonConstants.GET_LANGUAGES_SUCCESS,
        CommonConstants.GET_LANGUAGES_FAILED
      ]
    }
  };
}
